import { render, staticRenderFns } from "./ranks.vue?vue&type=template&id=189e300c&scoped=true&"
import script from "./ranks.vue?vue&type=script&lang=js&"
export * from "./ranks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e300c",
  null
  
)

export default component.exports